import { ReduxAction } from '../types';

type HTTPVerb = 'fetchAll' | 'fetch' | 'create' | 'update' | 'delete' | 'merge' | 'restore';
type RequestState = 'Requested' | 'Succeeded' | 'Failed' | null;
type ActionCreatorKey = HTTPVerb | `${HTTPVerb}${RequestState}`;
export type ActionCreators = {
  [key in ActionCreatorKey]?: (payload?: any) => ReduxAction;
};

// object of action creators keyed by httpVerb + requestState. requestState is excluded for actions that can effect the
// redux store immediately and may or may not have associated HTTP requests dispatched asyncronously
export const requestActions = (
  resourceType: string,
  httpVerbs: Array<HTTPVerb> = ['fetchAll', 'fetch', 'create', 'update', 'delete', 'restore'],
): ActionCreators => {
  return httpVerbs.reduce((actionCreators: ActionCreators, verb: HTTPVerb) => {
    // "Requested" is included here for handling the case where a request is not dispatched immediately
    // in response to an action, e.g. autosave
    return [null, 'Requested', 'Succeeded', 'Failed'].reduce(
      (actionCreators: ActionCreators, requestState: RequestState) => {
        const key: ActionCreatorKey = requestState ? `${verb}${requestState}` : verb;
        const snakeCasedVerb = verb != 'fetchAll' ? verb : 'fetch_all';
        let actionType = `${snakeCasedVerb.toUpperCase()}_${resourceType.toUpperCase()}`;

        // pluralize resourceType for fetchAll action
        if (verb == 'fetchAll' && !['ACTIVITY'].includes(resourceType)) {
          actionType = `${actionType}S`;
        }

        if (requestState) {
          actionType = `${actionType}_${requestState.toUpperCase()}`;
        }

        const action: ReduxAction = { type: actionType };

        if (requestState == 'Failed') {
          action.error = true;
        }

        actionCreators[key] = (payload: any) => ({ ...action, payload });

        return actionCreators;
      },
      actionCreators,
    );
  }, {});
};
